import DateFnsUtils from '@date-io/date-fns';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import frLocale from 'date-fns/locale/fr';
import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import AppRoutes from 'AppRoutes';
import Globals from 'components/Globals';
import Loading from 'components/Loading';
import Notifier from 'components/Notifier';
import { AppProvider } from 'context';
import theme from 'theme';
import BrowserSupport from 'components/BrowserSupport';

function App() {
  return (
    <>
      <Router>
        <Suspense fallback={<Loading fullHeight />}>
          <AppRoutes />
        </Suspense>
        <BrowserSupport />
      </Router>
    </>
  );
}

const AppWithProviders = () => (
  <AppProvider>
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
        <Notifier />
        <CssBaseline />
        <Globals />
        <App />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  </AppProvider>
);

export default AppWithProviders;
